import React, { useEffect, useState, useCallback } from "react";
import Navigation from "../components/Navbar";
import Footer from "../components/Footer";
import awardStyles from "../styles/AwardsAndAchievements.module.css";
import EventCarousel from "../components/AwardsCorouselDesign";

// GATE Summit Images for Corousal design
import gateImg from "../assests/images/GateSummit.png";
import GateSummit1 from "../assests/images/GATE Summit1.jpeg";
import GateSummit2 from "../assests/images/GATE Summit2.jpeg";
import GateSummit3 from "../assests/images/GATE Summit3.jpeg";
import GateSummit4 from "../assests/images/G4.png";
import GateSummit5 from "../assests/images/G5.png";
import GateSummit6 from "../assests/images/G6.png";
import GateSummit7 from "../assests/images/GATE Summit7.jpeg";
import GateSummit8 from "../assests/images/GATE Summit8.jpeg";

// GATE Summit Images for Corousal design
import cosmoImg from "../assests/images/CosmoExpo.png";
import cosmoImg1 from "../assests/images/Cosmo1.jpg";
import cosmoImg2 from "../assests/images/Cosmo2.jpg";
import cosmoImg3 from "../assests/images/Cosmo3.jpg";
import cosmoImg4 from "../assests/images/Cosmo4.jpg";
import cosmoImg5 from "../assests/images/Cosmo5.png";
import cosmoImg6 from "../assests/images/Cosmo6.png";
import cosmoImg7 from "../assests/images/Cosmo7.png";

// NBFC Tech Summit Images for Corousal design
import techSummitImg from "../assests/images/NBFC Summit DarkBG.png";
import techSummitImg1 from "../assests/images/TechSummit1.png";
import techSummitImg2 from "../assests/images/TechSummit2.png";
import techSummitImg3 from "../assests/images/TechSummit3.png";
import techSummitImg4 from "../assests/images/TechSummit4.png";

import heroAwardImg1 from "../assests/images/awardHero.png";
import heroAwardImg2 from "../assests/images/awardCertificate.png";
import heroAwardImg3 from "../assests/images/awardHall.png";
import featuredImg from "../assests/images/FeaturedInStartups.png";
import Seo from "../components/Seo";

const gateImages = [
  { src: gateImg, type: "logo" },
  { src: GateSummit1 },
  { src: GateSummit2 },
  { src: GateSummit3 },
  { src: GateSummit4, type: "dark" },
  { src: GateSummit5, type: "logo" },
  { src: GateSummit6 },
  { src: GateSummit7 },
  { src: GateSummit8 },
];

const cosmoImages = [
  { src: cosmoImg, type: "logo" },
  { src: cosmoImg1 },
  { src: cosmoImg2 },
  { src: cosmoImg3 },
  { src: cosmoImg4 },
  { src: cosmoImg5, type: "dark" },
  { src: cosmoImg6 },
  { src: cosmoImg7 },
];

const techImages = [
  { src: techSummitImg, type: "logo" },
  { src: techSummitImg1 },
  { src: techSummitImg2 },
  { src: techSummitImg3 },
  { src: techSummitImg4 },
];

const AwardsAndAchievements = () => {
  // Hero Slider State
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  const heroImages = [
    { src: heroAwardImg1, alt: "Cloudare Awards Recognition" },
    { src: heroAwardImg2, alt: "Cloudare Certificate of Excellence" },
    { src: heroAwardImg3, alt: "Cloudare Award Hall" },
  ];

  const totalSlides = heroImages.length;

  // Auto-play slider
  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      nextSlide();
    }, 4000);

    return () => clearInterval(interval);
  }, [currentSlide, isPaused]);

  const nextSlide = useCallback(() => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentSlide((prev) => (prev + 1) % totalSlides);
      setIsTransitioning(false);
    }, 300);
  }, [totalSlides]);

  const goToSlide = (index) => {
    if (index === currentSlide) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentSlide(index);
      setIsTransitioning(false);
    }, 300);
  };

  // Intersection Observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(awardStyles["animate-in"]);
          }
        });
      },
      { threshold: 0.1 }
    );

    document
      .querySelectorAll(`.${awardStyles["animate-on-scroll"]}`)
      .forEach((el) => {
        observer.observe(el);
      });

    return () => observer.disconnect();
  }, []);

  const awards = [
    {
      id: 1,
      image: techSummitImg,
      title: "NBFC Tech Summit",
      subtitle: "21st NBFC100 Tech Summit by Elets Technomedia",
      award: "Outstanding Achievement in ERP Implementation for NBFCs",
      description: [
        'Cloudare Technologies marked a significant milestone at the 21st NBFC100 Tech Summit by Elets Technomedia with a prestigious industry recognition. At the 10th NBFC100 Leader of Excellence Awards 2025, Cloudare was honoured with the "Outstanding Achievement in ERP Implementation for NBFCs" award.',
        "The summit brought together leaders from the NBFC and BFSI ecosystem to celebrate innovation, technology excellence, and transformative impact. This recognition highlights Cloudare's expertise in delivering future-ready ERP solutions tailored to the unique needs of NBFCs.",
        "It stands as a testament to our commitment to compliance, scalability, and operational excellence in the financial services sector.",
      ],
      category: "Excellence Award",
      layout: "row",
    },
    {
      id: 2,
      image: cosmoImg,
      title: "COSMO TECH EXPO",
      subtitle: "Shree Ram Business Park, Raipur",
      award: "Technology Innovation Recognition",
      description: [
        "Cloudare Technologies proudly marked its presence at the COSMO Tech Expo, Raipur, held at Shree Ram Business Park, a growing hub for business innovation and technology exchange in Central India.",
        "The event brought together industry leaders, technology providers, and growing enterprises to explore emerging trends, digital solutions, and scalable business systems. Cloudare's recognition at the expo reflects its growing influence in delivering enterprise-grade technology and ERP solutions across industries.",
        "The event served as a platform for collaboration, knowledge sharing, and showcasing innovation-driven growth. This recognition reinforces Cloudare's commitment to enabling businesses with future-ready, efficient, and scalable digital solutions.",
      ],
      category: "Industry Recognition",
      layout: "row",
    },
    {
      id: 3,
      image: gateImg,
      title: "GATE Summit",
      subtitle: "Global Accounting Taxation and E-invoicing Summit",
      award: "Enterprise Transformation Leadership",
      description: [
        "Cloudare's participation in the GATE (Global Accounting Taxation and E-invoicing) Summit showcases our continued commitment to innovation, leadership, and enterprise transformation.",
        "The summit provided a platform for industry collaboration, knowledge exchange, and highlighting impactful technology solutions driving digital growth across sectors.",
      ],
      category: "Leadership Award",
      layout: "row",
    },
    {
      id: 4,
      image: featuredImg,
      title: "Featured In Leading Publications",
      subtitle: "Startup & Business Platforms",
      award: "Innovation-Driven Approach Recognition",
      description: [
        "Cloudare Technologies has been featured in leading startup and business platforms, recognizing our innovation-driven approach and impact in ERP and compliance solutions.",
        "These features further strengthen our position as a trusted implementation partner for enterprises across industries.",
      ],
      category: "Media Feature",
      layout: "column",
    },
  ];

  // Helper function to combine multiple CSS module classes
  const combineClasses = (...classes) => {
    return classes.filter(Boolean).join(" ");
  };

  return (
    <div className={awardStyles["awards-page"]}>
        <Seo path="/awards-and-achievements" />
      <Navigation />

      {/* Simple Banner Section */}
      <section className={awardStyles["awards-banner"]}>
        <h1>Awards & Achievements</h1>
        <p>Celebrating milestones that reflect our commitment to excellence</p>
      </section>

      {/* Hero Section */}
      <section className={awardStyles["awards-hero"]}>
        <div className={awardStyles["hero-background"]}>
          <div className={awardStyles["hero-pattern"]}></div>
          <div className={awardStyles["hero-gradient"]}></div>
        </div>

        <div className={awardStyles["hero-container"]}>
          <div
            className={combineClasses(
              awardStyles["hero-content"],
              awardStyles["animate-on-scroll"]
            )}
          >
            <div className={awardStyles["hero-badge"]}>
              <span className={awardStyles["badge-icon"]}>🏆</span>
              <span className={awardStyles["badge-text"]}>
                Award-Winning Excellence
              </span>
            </div>

            <h1 className={awardStyles["hero-title"]}>
              An <span className={awardStyles["highlight"]}>Award-Winning</span>
              <br />
              ERP & E-Invoicing
              <br />
              Implementation Company
            </h1>

            <p className={awardStyles["hero-description"]}>
              At Cloudare Technologies, we take pride in being recognized for
              our excellence in delivering technology-driven,
              compliance-focused, and scalable enterprise solutions. By
              combining deep industry expertise with innovative platforms and
              intelligent systems, we help organizations simplify complexity,
              enhance operational efficiency, and grow with confidence.
            </p>

            <p className={awardStyles["hero-subdescription"]}>
              Our awards and recognitions reflect the trust our clients place in
              us and our continued impact across industries—making Cloudare a
              partner of choice for businesses ready to scale.
            </p>
          </div>

          <div
            className={combineClasses(
              awardStyles["hero-visual"],
              awardStyles["animate-on-scroll"]
            )}
          >
            <div
              className={awardStyles["visual-wrapper"]}
              onMouseEnter={() => setIsPaused(true)}
              onMouseLeave={() => setIsPaused(false)}
            >
              <div className={awardStyles["visual-glow"]}></div>

              {/* Image Slider */}
              <div className={awardStyles["trophy-showcase"]}>
                <div className={awardStyles["slider-container"]}>
                  {heroImages.map((image, index) => (
                    <div
                      key={index}
                      className={combineClasses(
                        awardStyles["slide"],
                        index === currentSlide && awardStyles["active"],
                        isTransitioning && awardStyles["transitioning"]
                      )}
                    >
                      <img
                        src={image.src}
                        alt={image.alt}
                        className={awardStyles["hero-image"]}
                      />
                    </div>
                  ))}

                  {/* Slide Progress Bar */}
                  <div className={awardStyles["slide-progress"]}>
                    <div
                      className={awardStyles["progress-bar"]}
                      style={{
                        animationDuration: isPaused ? "0s" : "4s",
                        animationPlayState: isPaused ? "paused" : "running",
                      }}
                      key={currentSlide}
                    ></div>
                  </div>
                </div>

                {/* Slider Dots */}
                <div className={awardStyles["slider-dots"]}>
                  {heroImages.map((_, index) => (
                    <button
                      key={index}
                      className={combineClasses(
                        awardStyles["slider-dot"],
                        index === currentSlide && awardStyles["active"]
                      )}
                      onClick={() => goToSlide(index)}
                      aria-label={`Go to slide ${index + 1}`}
                    >
                      <span className={awardStyles["dot-inner"]}></span>
                    </button>
                  ))}
                </div>
              </div>

              {/* Floating Badges */}
              <div
                className={combineClasses(
                  awardStyles["floating-badge"],
                  awardStyles["badge-1"]
                )}
              >
                <span className={awardStyles["floating-icon"]}>⭐</span>
                <span className={awardStyles["floating-text"]}>Excellence</span>
              </div>
              <div
                className={combineClasses(
                  awardStyles["floating-badge"],
                  awardStyles["badge-2"]
                )}
              >
                <span className={awardStyles["floating-icon"]}>🎯</span>
                <span className={awardStyles["floating-text"]}>Innovation</span>
              </div>
              <div
                className={combineClasses(
                  awardStyles["floating-badge"],
                  awardStyles["badge-3"]
                )}
              >
                <span className={awardStyles["floating-icon"]}>🚀</span>
                <span className={awardStyles["floating-text"]}>Growth</span>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className={awardStyles["scroll-indicator"]}>
          <div className={awardStyles["scroll-mouse"]}>
            <div className={awardStyles["scroll-wheel"]}></div>
          </div>
          <span>Scroll to explore</span>
        </div>
      </section>

      {/* Awards Section */}
      <section className={awardStyles["awards-section"]}>
        <div
          className={combineClasses(
            awardStyles["section-header"],
            awardStyles["animate-on-scroll"]
          )}
        >
          <span className={awardStyles["section-tag"]}>Recognition</span>
          <h2 className={awardStyles["section-title"]}>Our Recent Awards</h2>
          <p className={awardStyles["section-description"]}>
            Celebrating milestones that reflect our commitment to excellence and
            innovation
          </p>
        </div>

        <div className={awardStyles["awards-grid"]}>
          {awards.map((award, index) => (
            <div
              key={award.id}
              className={combineClasses(
                awardStyles["award-card"],
                awardStyles["animate-on-scroll"],
                award.layout === "column" && awardStyles["column-layout"],
                index % 2 !== 0 &&
                  award.layout !== "column" &&
                  awardStyles["reverse"]
              )}
            >
              <div className={awardStyles["award-image-container"]}>
                <div className={awardStyles["image-frame"]}>
                  <div className={awardStyles["image-background"]}>
                    {award.title === "GATE Summit" && (
                      <EventCarousel images={gateImages} />
                    )}

                    {award.title === "COSMO TECH EXPO" && (
                      <EventCarousel images={cosmoImages} />
                    )}

                    {award.title === "NBFC Tech Summit" && (
                      <EventCarousel images={techImages} />
                    )}

                    {award.title === "Featured In Leading Publications" && (
                      <img src={award.image} alt={award.title} />
                    )}
                  </div>
                </div>
              </div>

              <div className={awardStyles["award-content"]}>
                <div className={awardStyles["content-header"]}>
                  <span className={awardStyles["category-tag"]}>
                    {award.category}
                  </span>
                  <div className={awardStyles["award-icon"]}>🏆</div>
                </div>

                <h3 className={awardStyles["award-title"]}>{award.title}</h3>
                <p className={awardStyles["award-subtitle"]}>
                  {award.subtitle}
                </p>

                <div className={awardStyles["award-highlight"]}>
                  <div className={awardStyles["highlight-icon"]}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                    </svg>
                  </div>
                  <p className={awardStyles["highlight-text"]}>{award.award}</p>
                </div>

                <div className={awardStyles["award-description"]}>
                  {award.description.map((para, idx) => (
                    <p key={idx}>{para}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AwardsAndAchievements;
